import styled from 'styled-components';

export const BlogItemStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: ${(props) => (props?.isGlobalCarousel ? '12px' : '0px')};
  
  .dealItemBox {
    width: 100%;
    max-width: 208px;
    margin-bottom: 16px;
    margin-left: 10px;

    @media (max-width: 1024px) {
      max-width: 180px;
    }
    .item {
      width: 100%;
      padding: 0;
      background: ${(props) => props.theme.color.white};
      border: 1px solid ${(props) => props.theme.color.lightGray};
      border-radius: 8px;
      
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      a {
        width: 100%;
        text-decoration: none;
        color: inherit;
      }
      
      .abcd {
        border-top-right-radius: 7px;
        border-top-left-radius: 7px;
        border-bottom-left-radius: 0px ;
        border-bottom-right-radius: 0px;
      }

      .name {
        width: 100%;
        height: 75px;
        text-align: left;
        margin: 0 0 8px 0;
        font-size: 16px;
        font-weight: 600;
        overflow: hidden;
        padding-left: 10px;
        padding-right: 10px
      }

      .delivery {
        height: 25px;
        background: none; !important
        color: ${(props) => props.theme.text.medium};
        font-size: 12px;
        font-family: 'Mulish';
        font-weight: 400;
        text-align: left;
        padding-left: 10px;
        
        img {
            border-radius: 50%;
        }
        
        span {
            font-weight: 400;   
        }
      }

      .deliverySecond {
        margin-bottom: 3px;
        height: 39px;
        background: none !important;
        color: ${(props) => props.theme.text.medium};
        font-size: 12px;
        font-family: Mulish;
        font-weight: 400;
        text-align: left;
        padding-left: 10px;
        
        img {
            border-radius: 50%;
        }
    
        span {
            width: 137px;
            font-weight: 400;
            position: absolute;
            margin-left: 5px;
            margin-top: 7px;   
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
      }
    }
    
  }

  @media (max-width: 820px) {
    padding: 0;

    .dealItemBox {
      max-width: unset;
      margin: 0 6px;
    }
  }

  @media (max-width: 480px) {
    .row {
      .col-lg-12 {
        padding: 0;
      }
    }

    .dealItemBox {
      max-width: 100%;
      margin: 4px;

      .item {
        padding: 10px;
        border-radius: 8;

        .name {
          height: 50px;
          font-size: 14px;
          line-height: 17px;
          margin-bottom: 2px;
        }
    
        .delivery {
          height: 30px;
          background-position: 0 6px;
          font-size: 11px;
          line-height: 14px;
          margin-bottom: 4px;
        }
        
      }
    }
  }

  @media (max-width: 380px) {
    .slick-slide {
      width: 65vw !important;
    }
  }
`;